import type { CardStyles } from '../../ThemeTypes';
import colors from '../colors';

const cards: CardStyles = {
  card: {
    borderRadius: '1rem',
    '${max.md}': {
      padding: '28px 32px !important',
    },
    '${max.sm}': {
      padding: '24px 15px !important',
    },
  },
  standardLayoutCard: {
    borderRadius: '0.25rem',
    '.card-body': {
      padding: '0.8rem 2.5rem 0.8rem 0.8rem',
    },
  },
  onboardingCard: {
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    logo: {
      display: 'none',
      '${min.sm}': {
        display: 'none',
      },
      '${min.lg}': {
        display: 'none',
      },
    },
  },
  appCard: {
    background: colors.white,
    maxWidth: '810px !important',
    paddingPhone: '32px 32px',
    paddingDesktop: '10px 80px 40px',
    borderRadius: '1rem !important',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    border: 'none',
  },
};

export default cards;
